/* eslint-disable no-unsafe-optional-chaining */
import {
  Dispatch,
  SetStateAction,
  useContext,
  useEffect,
  useState,
} from 'react'
import {
  Checkbox,
  MaskedInput2,
  MultiSelect,
  Select2,
  Input2,
} from 'components/index'
import { UserContext } from 'context/userContext'
import { useStorage } from 'hooks'
import { numberToMoney, optionsLevels } from 'helper/utils'
import { selectOptions } from './factory'
import { ShowToolTipContainer, Suffix } from './style'

export const InfoProduto = ({ toggleCap }: any) => {
  const { data, setData, checkbox } = useContext(UserContext)
  const [user] = useStorage('User')
  const notUperLevel = !['OWNER', 'DIRECTOR'].includes(
    optionsLevels[user.level]
  )

  return (
    <>
      <div className="new-token-subtitle">
        <h4>
          {notUperLevel ? 'Informações da captação' : 'Informações do produto'}
        </h4>
      </div>
      <div className="new-token-container">
        <MaskedInput2
          disabled
          dataTestId="full-name-input"
          type="text"
          large
          handleChange={(e: any) => console.log(e)}
          placeholder="Nome completo da captação"
          name="name"
          defaultValue={data?.name}
        />
        <MaskedInput2
          dataTestId="short-name-input"
          disabled
          type="text"
          large
          handleChange={(e: any) => console.log(e)}
          placeholder="Nome resumido"
          name="shortName"
          defaultValue={data?.shortName}
        />
        <MaskedInput2
          disabled
          dataTestId="acronym-input"
          type="text"
          large
          handleChange={(e: any) => console.log(e)}
          placeholder="Sigla do produto"
          name="tick"
          defaultValue={data?.tick}
        />
        <Select2
          placeholder="Tipo de contrato"
          name="type"
          dataTestId="type-investment-select"
          hasAsterisk
          large
          disabled={
            toggleCap === 'Proposta base' ? false : notUperLevel || checkbox
          }
          options={selectOptions.type}
          onChange={(e: any) => {
            setData((oldValue: any) => ({
              ...oldValue,
              type: e,
            }))
          }}
          value={data?.type}
        />
        <MultiSelect
          hasAsterisk
          placeholder="Garantia"
          options={selectOptions.guaranteeList}
          name="guaranteeList"
          dataTestId="guarantee-select"
          large
          disabled={
            toggleCap === 'Proposta base' ? false : notUperLevel || checkbox
          }
          onChange={(e: any) => {
            const hasNaoPossui = e.some(
              (item: any) => item.value === 'Não possui'
            )

            const newValue = hasNaoPossui
              ? [{ label: 'Não possui', value: 'Não possui' }]
              : e.filter((item: any) => item.value !== 'Não possui')

            setData((oldValue: any) => ({
              ...oldValue,
              guaranteeList: newValue,
            }))
          }}
          defaultValue={data?.guaranteeList}
        />
      </div>
    </>
  )
}

type CondicaoRentaProps = {
  isCaptationsSelected: boolean
  isEnpreendimentoSelected: boolean
}

export const CondicaoRenta: React.FC<CondicaoRentaProps> = ({
  isCaptationsSelected,
  isEnpreendimentoSelected,
}) => {
  const { data, setData, checkbox } = useContext(UserContext)

  const [user] = useStorage('User')
  const [juros, setJuros] = useState<any>({
    min: 0,
    max: 100,
    show: false,
    warning: null,
  })
  const notUperLevel = !['OWNER', 'DIRECTOR'].includes(
    optionsLevels[user.level]
  )

  const isDisabled = () => {
    if (notUperLevel) return true
    if (checkbox) return !(isCaptationsSelected || isEnpreendimentoSelected)
    if (!checkbox) return false
  }

  const jurusIsDisabled = () => {
    if (notUperLevel) return false
    if (checkbox) return !(isCaptationsSelected || isEnpreendimentoSelected)
    if (!checkbox) return false
  }

  useEffect(() => {
    if (!data?.recurrencyType || !data?.enterpriseCreatedAt) return
    const dates = data?.enterpriseCreatedAt?.split('/')
    const isNew = Number(dates[2]) >= 2025
    if (!isNew)
      return setJuros({ min: 0, max: 100, warning: null, show: false })
    if (['QUARTERLY', 'ANNUALLY'].includes(data?.recurrencyType.value)) {
      return setJuros({
        min: 18,
        max: 21,
        warning:
          data?.recurrencyType.value === 'QUARTERLY'
            ? 'Pagto trimestral: 18% a 21%'
            : 'Pagto anual: 18% a 21%',
        show: true,
      })
    }
    if (data?.recurrencyType.value === 'DEFAULT')
      return setJuros({
        min: 21,
        max: 24,
        warning: 'No vencimento: 21% a 24%',
        show: true,
      })
    setJuros({
      min: 16,
      max: 18,
      warning:
        data?.recurrencyType.value === 'DAILY'
          ? 'Pagto diário: 16% a 18%'
          : 'Pagto mensal: 16% a 18%',
      show: true,
    })
  }, [data?.recurrencyType])

  return (
    <>
      <div className="new-token-subtitle">
        <h4>Condições da Rentabilidade</h4>
      </div>
      <div className="new-token-container">
        <Select2
          disabled={isDisabled()}
          placeholder="Indexador"
          dataTestId="indexer-select"
          name="paymentType"
          hasAsterisk
          large
          options={selectOptions.paymentType}
          onChange={(e: any) => {
            setData((oldValue: any) => ({
              ...oldValue,
              paymentType: e,
              indiceId: e?.value === 'PRE' && null,
            }))
          }}
          value={data?.paymentType}
        />
        <div className="new-token-div-juros">
          <Select2
            small
            placeholder="Índice"
            name="indiceId"
            dataTestId="index-select"
            disabled={isDisabled() || data?.paymentType?.value === 'PRE'}
            options={selectOptions.indiceId}
            onChange={(e: any) => {
              setData((oldValue: any) => ({
                ...oldValue,
                indiceId: e,
              }))
            }}
            value={data?.indiceId}
          />
          <ShowToolTipContainer>
            <span className="new-token-plus">+</span>
            <MaskedInput2
              min={0}
              max={100}
              hasAsterisk
              small
              dataTestId="rate-input"
              disabled={jurusIsDisabled()}
              type="jurosAno"
              handleChange={(e: any) => {
                setData((oldValue: any) => ({
                  ...oldValue,
                  profitability: e,
                }))
                setJuros((prev: any) => ({
                  ...prev,
                  show: false,
                }))
              }}
              placeholder="Juros"
              name="profitability"
              defaultValue={data?.profitability}
            />
          </ShowToolTipContainer>
        </div>
        <Select2
          placeholder="Imposto de renda"
          hasAsterisk
          dataTestId="income-tax-select"
          large
          disabled={isDisabled()}
          name="IRType"
          options={selectOptions.IRType}
          onChange={(e: any) => {
            setData((oldValue: any) => ({
              ...oldValue,
              IRType: e,
            }))
          }}
          value={data?.IRType}
        />
        <Select2
          placeholder="Período de cotização de entrada"
          name="cotizationIn"
          hasAsterisk
          disabled={isDisabled()}
          dataTestId="entry-quotation-period-select"
          large
          options={selectOptions.cotizationIn}
          onChange={(e: any) => {
            setData((oldValue: any) => ({
              ...oldValue,
              cotizationIn: e,
            }))
          }}
          value={data?.cotizationIn}
        />
        <Select2
          placeholder="Período de cotização de saída"
          name="cotizationOut"
          dataTestId="exit-quotation-period-select"
          hasAsterisk
          large
          disabled={isDisabled()}
          options={selectOptions.cotizationOut}
          onChange={(e: any) => {
            setData((oldValue: any) => ({
              ...oldValue,
              cotizationOut: e,
            }))
          }}
          value={data?.cotizationOut}
        />
        <Select2
          hasAsterisk
          large
          dataTestId="exit-quoted-profit-select"
          placeholder="Cotização de saída rentabilizada"
          name={'isCotizationProfitable'}
          options={selectOptions.isCotizationProfitable}
          disabled={isDisabled()}
          onChange={(e: any) => {
            setData((oldValue: any) => ({
              ...oldValue,
              isCotizationProfitable: e,
            }))
          }}
          value={data?.isCotizationProfitable}
        />
      </div>
    </>
  )
}
type BonusProps = {
  isCaptationsSelected: boolean
  isEnpreendimentoSelected: boolean
  checkbox: boolean
  setCheckbox: Dispatch<SetStateAction<boolean>>
}

export const Bonus: React.FC<BonusProps> = ({
  isCaptationsSelected,
  isEnpreendimentoSelected,
  checkbox,
  setCheckbox,
}) => {
  const { data, setData } = useContext(UserContext)
  const [user] = useStorage('User')
  const notUperLevel = !['OWNER', 'DIRECTOR'].includes(
    optionsLevels[user.level]
  )
  const isJurosComposto = ['QUARTERLY', 'ANNUALLY', 'DEFAULT'].includes(
    data?.recurrencyType?.value
  )
  const isDisabled = () => {
    if (notUperLevel) return false
    if (isJurosComposto) return true
    if (checkbox) return !(isCaptationsSelected || isEnpreendimentoSelected)
    if (!checkbox) return false
  }

  const getMonths = () => {
    const arr = []

    for (let i = 0; i < Number(data.deadline); i++) {
      arr.push({
        label: i + 1,
        value: i + 1,
      })
    }
    return arr
  }

  useEffect(() => {
    setData((oldValue: any) => ({
      ...oldValue,
      bonusMonths: null,
    }))
  }, [data.deadline])

  useEffect(() => {
    if (!checkbox) {
      const { ...resto } = data
      setData(resto)
    }
  }, [checkbox])

  useEffect(() => {
    if (isJurosComposto) {
      setData((oldValue: any) => ({
        ...oldValue,
        bonusMonths: null,
        // profitabilityBonus: null,
      }))
      setCheckbox(false)
    }
  }, [data?.recurrencyType])

  return (
    <>
      <div className="new-token-subtitle">
        <Checkbox
          label="Contrato com bônus"
          setChecked={() => setCheckbox(!checkbox)}
          checked={checkbox}
          disabled={isJurosComposto}
        />
      </div>

      {checkbox && (
        <>
          <div className="new-token-subtitle">
            <h4>Bônus de contrato</h4>
          </div>
          <div className="new-token-container">
            <Select2
              key={`meses+bonus+select`}
              placeholder="Meses"
              dataTestId="bonus-months-select"
              name={'bonusMonths'}
              small
              disabled={isDisabled()}
              options={getMonths()}
              onChange={(e: any) => {
                setData((oldValue: any) => ({
                  ...oldValue,
                  bonusMonths: e,
                }))
              }}
              value={data?.bonusMonths}
            />
            <div className="new-token-div-juros" style={{ width: 'auto' }}>
              <MaskedInput2
                large
                dataTestId="bonus-rate-months-input"
                type="jurosPercent"
                disabled={isDisabled()}
                handleChange={(e: any) => {
                  setData((oldValue: any) => ({
                    ...oldValue,
                    profitabilityBonus: e,
                  }))
                }}
                placeholder="Juros ao mês"
                name="profitabilityBonus"
                defaultValue={data?.profitabilityBonus}
              />
            </div>
          </div>
        </>
      )}
    </>
  )
}

type InfoContratoProps = {
  isCaptationsSelected: boolean
  isEnpreendimentoSelected: boolean
}

export const InfoContrato: React.FC<InfoContratoProps> = ({
  isCaptationsSelected,
  isEnpreendimentoSelected,
}) => {
  const { data, setData, checkbox } = useContext(UserContext)
  const [user] = useStorage('User')
  const notUperLevel = !['OWNER', 'DIRECTOR'].includes(
    optionsLevels[user.level]
  )

  const isDisabled = () => {
    if (notUperLevel) return true
    if (checkbox) return !(isCaptationsSelected || isEnpreendimentoSelected)
    if (!checkbox) return false
  }

  const deadlineIsDisabled = () => {
    if (notUperLevel) return false
    if (checkbox) return
    !(isCaptationsSelected || isEnpreendimentoSelected)
    if (!checkbox) return false
  }

  return (
    <>
      <div className="new-token-subtitle">
        <h4>Informações do contrato</h4>
      </div>
      <div className="new-token-container">
        <Select2
          // disabled={isDisabled()}
          dataTestId="rate-payment-type-select"
          placeholder="Pagamento dos juros"
          name="recurrencyType"
          large
          hasAsterisk
          options={selectOptions.recurrencyType}
          onChange={(e: any) => {
            setData((oldValue: any) => ({
              ...oldValue,
              recurrencyType: e,
            }))
          }}
          value={data?.recurrencyType}
        />
        <Select2
          disabled={isDisabled()}
          placeholder="Liquidez"
          large
          dataTestId="liquidity-select"
          name="principalLiquidityType"
          options={selectOptions.principalLiquidityType}
          hasAsterisk
          onChange={(e: any) => {
            setData((oldValue: any) => ({
              ...oldValue,
              principalLiquidityType: e,
            }))
          }}
          value={data?.principalLiquidityType}
        />
        {data?.recurrencyType?.value === 'QUARTERLY' ? (
          <div className="new-token-div-prazo">
            <Input2
              large
              type={'number'}
              name={'deadline'}
              onKeyDown
              step={3}
              min={3}
              hasAsterisk
              placeholder="Prazo do contrato"
              disabled={deadlineIsDisabled()}
              onChange={(e: any) => {
                setData((oldValue: any) => ({
                  ...oldValue,
                  deadline: e.target.value,
                }))
              }}
              defaultValue={data?.deadline}
            />
            {data?.deadline && <Suffix>meses</Suffix>}
          </div>
        ) : (
          <div className="new-token-div-juros">
            <MaskedInput2
              large
              dataTestId="deadline-input"
              hasAsterisk
              type="months"
              disabled={deadlineIsDisabled()}
              handleChange={(e: any) => {
                setData((oldValue: any) => ({
                  ...oldValue,
                  deadline: e,
                }))
              }}
              placeholder="Prazo do contrato"
              name="deadline"
              defaultValue={data?.deadline}
            />
          </div>
        )}
      </div>
    </>
  )
}

export const DadosEmpreeendimentoRetroativo = () => {
  const { retroData } = useContext(UserContext)
  const [key, setKey] = useState(0)

  useEffect(() => {
    // setRetroData({})
    setKey(key + 1)
  }, [])
  return (
    <>
      <div className="new-token-subtitle">
        <h4>Dados do empreendimento</h4>
      </div>
      <div className="new-token-container">
        <MaskedInput2
          disabled
          type="text"
          dataTestId="full-name-input"
          handleChange={(e: any) => console.log(e)}
          placeholder="Nome completo do empreendimento"
          name="name"
          large
          uniqKey={`retri_emprend1_${key}`}
          defaultValue={retroData?.name}
        />
        <MaskedInput2
          disabled
          dataTestId="short-name-input"
          large
          type="text"
          handleChange={(e: any) => console.log(e)}
          placeholder="Nome resumido"
          name="short"
          defaultValue={retroData?.short}
          uniqKey={`retri_emprend2_${key}`}
        />
        <MaskedInput2
          large
          dataTestId="acronym-input"
          disabled
          type="text"
          handleChange={(e: any) => console.log(e)}
          placeholder="Sigla do empreendimento"
          name="tick"
          defaultValue={retroData?.tick}
          uniqKey={`retri_emprend3_${key}`}
        />
      </div>
    </>
  )
}

export const InfoContratoRetroativo = () => {
  const { retroData, setRetroData } = useContext(UserContext)
  const [key, setKey] = useState(0)

  useEffect(() => {
    // setRetroData({})
    setKey(key + 1)
  }, [])
  return (
    <>
      <div className="new-token-subtitle">
        <h4>Informações do contrato</h4>
      </div>
      <div className="new-token-container">
        <div
          style={{ justifyContent: 'flex-start', display: 'flex', gap: '1rem' }}
        >
          <MaskedInput2
            dataTestId="deadline-contract-input"
            type="number"
            handleChange={(e: any) => {
              setRetroData((oldValue: any) => ({
                ...oldValue,
                deadline: e,
              }))
            }}
            hasAsterisk
            placeholder="Prazo do contrato"
            name="deadline"
            defaultValue={retroData?.deadline}
            uniqKey={`retri_emprend4_${key}`}
          />
          <span className="new-token-plus">meses</span>
        </div>
        <Select2
          uniqKey={`retri_emprend5_${key}`}
          placeholder="Pagamento dos juros"
          dataTestId="rate-payment-type-select"
          large
          hasAsterisk
          name="recurrencyType"
          options={selectOptions.recurrencyType}
          onChange={(e: any) => {
            setRetroData((oldValue: any) => ({
              ...oldValue,
              recurrencyType: e,
            }))
          }}
          value={retroData?.recurrencyType}
        />
        <Select2
          uniqKey={`retri_emprend6_${key}`}
          dataTestId="liquidity-select"
          small
          hasAsterisk
          placeholder="Liquidez"
          name="liquidity"
          options={selectOptions.principalLiquidityType}
          onChange={(e: any) => {
            setRetroData((oldValue: any) => ({
              ...oldValue,
              liquidity: e,
            }))
          }}
          value={retroData?.liquidity}
        />
        <Select2
          uniqKey={`retri_emprend7_${key}`}
          placeholder="Período de cotização de saída"
          name="cotizationOut"
          large
          hasAsterisk
          dataTestId="exit-quotation-period-select"
          options={selectOptions.cotizationOut}
          onChange={(e: any) => {
            setRetroData((oldValue: any) => ({
              ...oldValue,
              cotizationOut: e,
            }))
          }}
          value={retroData?.cotizationOut}
        />
        <Select2
          // disabled={notUperLevel}
          hasAsterisk
          dataTestId="exit-quoted-profit-select"
          uniqKey={`retri_emprend8_${key}`}
          placeholder="Cotização de saída rentabilizada"
          name={'isCotizationProfitable'}
          large
          options={selectOptions.isCotizationProfitable}
          onChange={(e: any) => {
            setRetroData((oldValue: any) => ({
              ...oldValue,
              isCotizationProfitable: e,
            }))
          }}
          value={retroData?.isCotizationProfitable}
        />
        <Select2
          uniqKey={`retri_emprend9_${key}`}
          dataTestId="indexer-select"
          small
          hasAsterisk
          placeholder="Indexador"
          name="paymentType"
          options={selectOptions.paymentType}
          onChange={(e: any) => {
            setRetroData((oldValue: any) => ({
              ...oldValue,
              paymentType: e,
              indiceId: e?.value === 'PRE' && null,
            }))
          }}
          value={retroData?.paymentType}
        />
      </div>
    </>
  )
}

export const CondiCaptacaoRetroativo = () => {
  const { retroData, setRetroData } = useContext(UserContext)
  const [key, setKey] = useState(0)

  useEffect(() => {
    // setRetroData({})
    setKey(key + 1)
  }, [])
  return (
    <>
      <div className="new-token-subtitle">
        <h4>Condiçōes da proposta</h4>
      </div>
      <div className="new-token-container">
        <MaskedInput2
          uniqKey={`retri_emprend10_${key}`}
          large
          hasAsterisk
          dataTestId="investiment-value-input"
          type="money"
          handleChange={(e: any) => {
            setRetroData((oldValue: any) => ({
              ...oldValue,
              value: e,
            }))
          }}
          placeholder={'Valor do investimento'}
          name="value"
          defaultValue={retroData?.value}
        />
        <MaskedInput2
          uniqKey={`retri_emprend11_${key}`}
          large
          hasAsterisk
          dataTestId="quota-price-input"
          type="money"
          handleChange={(e: any) => {
            setRetroData((oldValue: any) => ({
              ...oldValue,
              quotaValue: e,
            }))
          }}
          placeholder="Preço da cota"
          name="quotaValue"
          defaultValue={retroData?.quotaValue}
        />
        <MaskedInput2
          uniqKey={`retri_emprend12_${key}`}
          large
          dataTestId="quota-amount-input"
          type="text"
          disabled
          handleChange={(e: any) => {
            console.log(e)
          }}
          placeholder="Quantidade de cotas"
          name="amount"
          defaultValue={retroData?.amount}
        />
      </div>
    </>
  )
}

export const JustGuarantee = () => {
  const { retroData, setRetroData } = useContext(UserContext)
  const [key, setKey] = useState(0)

  useEffect(() => {
    // setRetroData({})
    setKey(key + 1)
  }, [])
  return (
    <>
      <div className="new-token-subtitle">
        <h4>Garantia do contrato</h4>
      </div>
      <div className="new-token-container">
        <Select2
          uniqKey={`retri_emprend13_${key}`}
          placeholder="Garantia"
          large
          hasAsterisk
          dataTestId="guarantee-select"
          options={selectOptions.guaranteeList}
          name="guaranteeList"
          onChange={(e: any) => {
            setRetroData((oldValue: any) => ({
              ...oldValue,
              guaranteeList: e,
            }))
          }}
          value={retroData?.guaranteeList}
        />
      </div>
    </>
  )
}

export const DadosContratoRetroativo = () => {
  const { retroData, setRetroData } = useContext(UserContext)
  const [key, setKey] = useState(0)

  useEffect(() => {
    setRetroData({})
    setKey(key + 1)
  }, [])
  return (
    <>
      <div className="new-token-subtitle">
        <h4>Dados do contrato</h4>
      </div>
      <div className="new-token-container">
        <MaskedInput2
          uniqKey={`retri_emprend14_${key}`}
          dataTestId="investiment-date-input"
          large
          hasAsterisk
          type="date"
          handleChange={(e: any) => {
            setRetroData((oldValue: any) => ({
              ...oldValue,
              investAt: e.target.value,
            }))
          }}
          placeholder="Data do investimento"
          name="investAt"
          defaultValue={retroData?.investAt}
        />
        <MaskedInput2
          uniqKey={`retri_emprend15_${key}`}
          large
          hasAsterisk
          dataTestId="first-payment-date-input"
          type="date"
          handleChange={(e: any) => {
            setRetroData((oldValue: any) => ({
              ...oldValue,
              firstAt: e.target.value,
            }))
          }}
          placeholder="Data do início do pagamento"
          name="firstAt"
          defaultValue={retroData?.firstAt}
        />
        <MaskedInput2
          uniqKey={`retri_emprend16_${key}`}
          disabled
          large
          dataTestId="last-payment-date-input"
          type="date"
          handleChange={(e: any) => {
            console.log(e)
          }}
          placeholder="Data do último do pagamento"
          name="lastAt"
          defaultValue={retroData?.last}
        />
        <MaskedInput2
          uniqKey={`retri_emprend17_${key}`}
          disabled
          large
          dataTestId="return-date-input"
          type="date"
          handleChange={(e: any) => {
            console.log(e)
          }}
          placeholder="Data do retorno do principal"
          name="rescueAt"
          defaultValue={retroData?.rescueAt}
        />
      </div>
    </>
  )
}

export const RentabilidadeRetroativo = () => {
  const { retroData } = useContext(UserContext)
  const [key, setKey] = useState(0)

  useEffect(() => {
    // setRetroData({})
    setKey(key + 1)
  }, [])
  return (
    <>
      <div className="new-token-subtitle">
        <h4>Rentabilidade</h4>
      </div>
      <div className="new-token-container">
        <MaskedInput2
          uniqKey={`retri_emprend18_${key}`}
          large
          dataTestId="tax-profitability-input"
          disabled
          type="text"
          handleChange={(e: any) => {
            console.log(e)
          }}
          placeholder="Taxa de juros a.a. (média ponderada)"
          name="profitability"
          defaultValue={
            retroData?.profitability && `${retroData?.profitability}% a.a.`
          }
        />

        <MaskedInput2
          uniqKey={`retri_emprend19_${key}`}
          large
          dataTestId="paid-profitability-input"
          disabled
          type="text"
          handleChange={(e: any) => {
            console.log(e)
          }}
          placeholder={'Rentabilidade paga'}
          name="paidProfitability"
          defaultValue={
            retroData?.paidProfitability &&
            `R$ ${numberToMoney(retroData?.paidProfitability)}`
          }
        />
        <MaskedInput2
          uniqKey={`retri_emprend20_${key}`}
          large
          dataTestId="to-pay-profitability-input"
          disabled
          type="text"
          handleChange={(e: any) => {
            console.log(e)
          }}
          placeholder={'Rentabilidade a pagar'}
          name="toPayProfitability"
          defaultValue={
            retroData?.toPayProfitability &&
            `R$ ${numberToMoney(retroData?.toPayProfitability)}`
          }
        />
      </div>
    </>
  )
}
